import AbstractType from "@/api/types/AbstractType";

export default class UserAgreement extends AbstractType {
    public pointOfTime: string|null = null

    constructor(data: any) {
        super();
        this.pointOfTime = data.pointOfTime
    }
}